import { css } from '@emotion/react';
import { forwardRef, LabelHTMLAttributes } from 'react';
import cns from 'classnames';
import { ContextProps } from './FormControlContext';
import { withForm } from './withForm';

export const LABEL_CLASSNAME = '__mapiui_label';

export interface LabelProps
  extends LabelHTMLAttributes<HTMLLabelElement>,
    ContextProps {}

const applyMainStyles =
  ({
    isInvalid,
    isVerified,
    isCompleted,
    isDisabled,
  }: Pick<
    LabelProps,
    'isInvalid' | 'isCompleted' | 'isDisabled' | 'isVerified'
  >) =>
  (theme) => {
    const defaultStyle = css(theme.form.label.defaultStyles);

    const styles = [defaultStyle];

    if (isInvalid) {
      styles.push(css(theme.form.label.isInvalid));
    }
    if (isCompleted) {
      styles.push(css(theme.form.label.isCompleted));
    }
    if (isDisabled) {
      styles.push(css(theme.form.label.isDisabled));
    }
    if (isVerified) {
      styles.push(css(theme.form.label.isVerified));
    }

    return css(...styles);
  };

const InternalLabel = forwardRef<HTMLLabelElement, LabelProps>(
  (
    {
      children,
      className,
      controlId,
      isDisabled,
      isVerified,
      isInvalid,
      isCompleted,
      ...props
    }: LabelProps,
    ref
  ) => (
    <label
      ref={ref}
      htmlFor={controlId}
      className={cns(LABEL_CLASSNAME, className)}
      css={applyMainStyles({ isDisabled, isVerified, isInvalid, isCompleted })}
      {...props}
    >
      {children}
    </label>
  )
);

InternalLabel.displayName = 'Label';

export const Label = withForm<LabelProps>(InternalLabel);
